<template>
  <div class="centerx">
    <vs-button @click="popupActivo=true" class="btn btn--green">
      <i class="fas fa-plus-circle"></i>
      Nuova mansione
    </vs-button>
    <vs-popup class="holamundo" :active.sync="popupActivo">
      <!-- Questo è il codice da inserire nella vista della route -->
      <section class="section--sidebar-user">
        Caricare il file people/partials/new_task.blade.php
      </section>
      <!-- Qua finisce il codice da inserire nella vista della route -->
    </vs-popup>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        popupActivo:false,
      }
    }
  }
</script>
